import type { NavGroup, NavLink } from '@/types'

export const MAIN_NAV: Array<NavLink> = [
    { label: 'Product', href: '/product' },
    { label: 'Solutions', href: '/solutions' },
    { label: 'Resources', href: '/resources' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' }
]

export const FOOTER_NAV: Array<NavGroup> = [
    {
        title: 'Product',
        links: [
            { label: 'Overview', href: '/product' },
            { label: 'Features', href: '/features' },
            { label: 'Pricing', href: '/pricing' },
            { label: 'Request a demo', href: '/demo' }
        ]
    },
    {
        title: 'Solutions',
        links: [
            { label: 'Startups', href: '/solutions#startups' },
            { label: 'Growing businesses', href: '/solutions#growing-businesses' },
            { label: 'Finance teams', href: '/solutions#finance-teams' },
            { label: 'Enterprise', href: '/solutions#enterprise' }
        ]
    },
    {
        title: 'Resources',
        links: [
            { label: 'Library', href: '/resources' },
            { label: 'Guides', href: '/resources?category=guides' },
            { label: 'Insights', href: '/resources?category=insights' },
            { label: 'Playbooks', href: '/resources?category=playbooks' }
        ]
    },
    {
        title: 'Company',
        links: [
            { label: 'About', href: '/about' },
            { label: 'Contact', href: '/contact' },
            { label: 'Log in', href: '/login' },
            { label: 'Sign up', href: '/signup' }
        ]
    }
]

export const LEGAL_NAV: Array<NavLink> = [
    { label: 'Privacy policy', href: '/privacy' },
    { label: 'Terms of service', href: '/terms' }
]
